module.exports = __webpack_public_path__ + "static/media/search.05ff01e4.svg";